import { patientPopupZIndex } from "../../layout/patientStacking";
import { SIDE_PADDING } from "../consts/sizeConsts";
import styled from "@mui/material/styles/styled";

export const ExternalBackgroundOverlay = styled("div")({
  position: "absolute",
  bottom: 0,
  boxSizing: "border-box",
  width: "100%",
  height: "100%",
  padding: "14px",
  background: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  flexFlow: "column-reverse",
  zIndex: patientPopupZIndex,
  // Expand over the chat's container padding
  margin: `0 -${SIDE_PADDING}px`,
});
